jQuery(function() { 
	var tsmessages = { 
		'confirmclearselections': "Are you sure?", 
		'boxnotfull': "Your box isn't full yet! Please make [qty_left] more selections.", 
		'boxtoofull': "Your box is too full! Please remove [qty_over] selections.", 
		'toomanytype': "Your box has too many [type], please adjust your selections",
	}
	var tsboxes = [];
	tsboxes[2] = { milk: 2, dark: 2,  white: 2, other: 0, };
	tsboxes[4] = { milk: 4, dark: 4,  white: 4, other: 0 };
	tsboxes[6] = { milk: 6, dark: 6,  white: 6, other: 0, };
	tsboxes[8] = { milk: 8, dark: 8,  white: 8, other: 0, };
//  Edited by Nick to remove box of 10
//	tsboxes[10] = { milk: 10, dark: 10,  white: 10, other: 0, };
	tsboxes[12] = { milk: 12, dark: 12,  white: 12, other: 0, };
  //Edited by Nick (TUC) to remove limits as requested May 2018
 
	tsboxes[18] = { milk: 18, dark: 18,  white: 18, other: 0, };
	tsboxes[24] = { milk: 24, dark: 24,  white: 24, other: 0, };
	tsboxes[32] = { milk: 32, dark: 32,  white: 32, other: 0, };
    //Edited by Nick (TUC) to remove large boxes as requested Oct 2018
	//tsboxes[49] = { milk: 49, dark: 49,  white: 49, other: 0, };
	//tsboxes[70] = { milk: 70, dark: 70, white: 70, other: 0, };
  
  //Original settings:
  //	tsboxes[18] = { milk: 7, dark: 7,  white: 1, other: 4, };
//	tsboxes[24] = { milk: 9, dark: 9,  white: 1, other: 5, };
//	tsboxes[32] = { milk: 12, dark: 12,  white: 1, other: 7, };
//	tsboxes[49] = { milk: 18, dark: 18,  white: 1, other: 12, };
//	tsboxes[70] = { milk: 27, dark: 27, white: 2, other: 14, };

    //New boxes as of Sep 19:
  	tsboxes[9] = { milk: 9, dark: 9,  white: 9, other: 0, };
 	tsboxes[16] = { milk: 16, dark: 16,  white: 16, other: 0, };
	tsboxes[25] = { milk: 25, dark: 25,  white: 25, other: 0, };
	tsboxes[36] = { milk: 36, dark: 36,  white: 36, other: 0, };
  
  //TUC - To hide entries here, add // at the beginning of the line
	var tschoices = { 
	'Amaretto Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/amaretto-dark.jpg?v=1614838354', desc: 'Milk chocolate ganache infused with amaretto liqueur,  topped with freshly toasted sliced almonds.', type: 'dark'},
	'Amaretto Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/AmarettoM.jpg?4681301725968743650', desc: 'Milk chocolate ganache  infused with amaretto liqueur,  topped with freshly toasted sliced almonds.', type: 'milk'},
	'Berry Quartet Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/berry-quartet-dark.jpg?v=1614838354', desc: 'Milk chocolate ganache  combining black currant, raspberry, blackberry and strawberry finished in a tart raspberry sugar.', type: 'dark'},
	'Berry Quartet Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/BerryQuartetM.jpg?4681301725968743650', desc: 'Milk chocolate ganache  combining black currant, raspberry, blackberry and strawberry finished in a tart raspberry sugar.', type: 'milk'},
    'Black Forest Cherry Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/black-forest-cherry-red.jpg?v=1614838354', desc: 'Italian amarena cherry and sweet cherry syrup in a dark chocolate shell.', type: 'dark'},
	'Black Raspberry Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/black-raspberry-dark.jpg?v=1614838354', desc: 'Rich dark chocolate inside and out - created with pureed raspberry. ', type: 'dark'},
	'Blonde Bombshell Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/blongBombshellD.jpg?4681301725968743650', desc: 'Fragrant amaretto and brandy white chocolate ganache . ', type: 'dark'},
	'Blonde Bombshell White': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/BlondBombshell.jpg?4681301725968743650', desc: 'Fragrant amaretto and brandy white chocolate ganache . ', type: 'white'},
	'Cappuccino Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/cappuccino-dark.jpg?v=1614838354', desc: 'A creamy blend of espresso in milk and white chocolate ganache . ', type: 'dark'},
	'Cappuccino Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/cappuccinoM.jpg?4681301725968743650', desc: 'A creamy blend of espresso in milk and white chocolate ganache . ', type: 'milk'},
	'Chai Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/chai-milk.jpg?v=1617233910', desc: 'Creamy milk chocolate ganache  infused with rich chai spice.', type: 'milk'},
 	'Champagne Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/ChampagneM.jpg?15963548395286735259', desc: 'Champagne infused creamy milk chocolate truffle, garnished with sugar crystals.', type: 'milk'},
 	'Champagne Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/ChampagneD.jpg?15963548395286735259', desc: 'Champagne infused creamy milk chocolate truffle, garnished with sugar crystals.', type: 'dark'},
	'Classic Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/classic-dark.jpg?v=1614838354', desc: 'Dark chocolate ganache , for those who like their chocolate straight up.', type: 'dark'},
	'Coconut Rum Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/coconut-rum-dark.jpg?v=1614838355', desc: 'A rich blend of amber rum and tender coconut in milk chocolate ganache .', type: 'dark'},
	'Coconut Rum Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/Coconut_Rum_Milk_2_Web_grande_38e94e05-876b-4237-ad12-17c6de6f91ec.jpg?4681301725968743650', desc: 'A rich blend of amber rum and tender coconut in milk chocolate ganache .', type: 'milk'},
//	'Espresso Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/Espresso_Truffle_Milk_Web_1024x1024_6f63b556-a605-4f51-9c5f-55e571d353c0.jpg?4681301725968743650', desc: '', type: 'milk'},
//	'Espresso Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/Espresso_Truffle_Dark_Web_1024x1024_9635cb46-5c36-4bdc-a7ec-e7ccd11516d4.jpg?4681301725968743650', desc: '', type: 'dark'},
//    'Egg Nog Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/unknown-dark-4.jpg?v=1614838356', desc: 'White chocolate ganache with spiced egg nog and amber rum.', type: 'dark'},
//    'Egg Nog Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/unknown-dark-4.jpg?v=1614838356', desc: 'White chocolate ganache with spiced egg nog and amber rum.', type: 'milk'},
	'Fierce Mild Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/fiercemild.JPG?6421132775114949446', desc: 'Salted milk chocolate ganache  dipped in 85% Colombian varietal extra dark chocolate, topped with cacao nibs.', type: 'dark'},
	'French Kiss Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/french-kiss-dark.jpg?v=1614838354', desc: 'Dark chocolate ganache  kissed with cognac & garnished with dark vermicelli.', type: 'dark'},
	'Gochujang Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/gochujang-dark.jpg?v=1784061643', desc: 'Dark chocolate truffle fired up with spicy Korean gochujang chili paste.', type: 'dark'},
	'Hazelnut Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/hazelnut-dark.jpg?v=1614838355', desc: 'Milk chocolate ganache  with roasted hazelnut purée.', type: 'dark'},
	'Hazelnut Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/HazelnutM.jpg?4681301725968743650', desc: 'Milk chocolate ganache  with roasted hazelnut purée.', type: 'milk'},
	'Irish Cream Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/BaileysD.jpg?25', desc: 'A union of milk and white chocolate ganache  warmed with Irish cream liqueur.', type: 'dark'},
	'Irish Cream Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/BaileysM.jpg?25', desc: 'A union of milk and white chocolate ganache  warmed with Irish cream liqueur.', type: 'milk'},
	'Italian Lover Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/ItalianLover.jpg?v=1614755263', desc: 'Cognac & Amaretto in dark chocolate ganache  garnished with a mocca bean.', type: 'dark'},
    'Kirsch Cherry Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/kirsch-cherry-purple.jpg?v=1614838355', desc: 'Italian amarena cherry soaked in Kirsch liqueur and infused Kirsch syrup in a dark chocolate shell.', type: 'dark'},
	'Ko Chang Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/kochang-dark.jpg?v=1614838355', desc: 'Take a journey to Thailand with infused lemongrass, lime and coconut in white chocolate ganache.', type: 'dark'},
	'Ko Chang White': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/KoChnagW.jpg?4681301725968743650', desc: 'Take a journey to Thailand with infused lemongrass, lime and coconut in white chocolate ganache.', type: 'white'},
    'Lemon Horse Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/lemon-horse-dark.jpg?v=1614838355', desc: 'Tangy lemon cream.', type: 'dark'},
    'Lemon Horse Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/lemon-horse-m.jpg?134', desc: 'Tangy lemon cream.', type: 'milk'},
	'London Fog Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/london-fog-milk.jpg?v=1614838355', desc: 'Organic Earl Grey tea with first-press Bergamot oil & vanilla infused into creamy milk chocolate ganache. Dipped in milk chocolate.', type: 'milk'},
	'Majorca Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/majorcaD.jpg?4681301725968743650', desc: 'Dulce de leche in white chocolate ganache .', type: 'dark'},
	'Majorca Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/majorca-milk.jpg?v=1614838355', desc: 'Dulce de leche in white chocolate ganache .', type: 'milk'},
    'Maple Walnut Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/maplewalnut-milk.jpg?v=1614838355', desc: 'Maple infused buttercream, roasted walnut in a milk chocolate shell.', type: 'milk'},
	'Orange Brandy Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/OrangeBrandyD.jpg?4681301725968743650', desc: 'Orange brandy whipped into dark chocolate ganache .', type: 'dark'},
	'Orange Brandy Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/OrangeBrandyM.jpg?4681301725968743650', desc: 'Orange brandy whipped into dark chocolate ganache .', type: 'milk'},
  //  'Pumpkin Pi Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/pumpkin-pi-dark-web.jpg?191', desc: 'Pumpkin pie spices whipped with real pumpkin into creamy milk chocolate truffle. ', type: 'dark'},
  //  'Pumpkin Pi Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/pumpkin-milk.jpg?v=1614838355', desc: 'Pumpkin pie spices whipped with real pumpkin into creamy milk chocolate truffle. ', type: 'milk'},
    'Raspberry Heart Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/rasp-heart-d.jpg?146', desc: 'White chocolate buttercream and raspberry confit centre in a dark chocolate shell.', type: 'dark'},
    'Raspberry Heart Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/raspberry-heart-milk.jpg?v=1614838356', desc: 'White chocolate buttercream and raspberry confit centre in a milk chocolate shell.', type: 'milk'},
	'Satsuma Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/SatsumaM.jpg?4681301725968743650', desc: 'Blood orange puree paired with milk chocolate ganache . ', type: 'milk'},
	'Satsuma Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/satsuma-dark.jpg?v=1614838356', desc: 'Blood orange puree paired with milk chocolate ganache . ', type: 'dark'},
    'Strawberry Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/strawberry-cream-dark.jpg?v=1614838356', desc: 'Tart strawberry cream.', type: 'dark'},
    'Strawberry Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/strawberry-m.jpg?134', desc: 'Tart strawberry cream.', type: 'milk'},
	'Swiss Miss Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/swiss-miss-milk.jpg?v=1614838356', desc: 'Pure simple milk chocolate ganache ', type: 'milk'},
	'Toffee Dark': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/ToffeeD.jpg?4681301725968743650', desc: 'A happy collision of vanilla ganache  and our family recipe of buttercrunch. ', type: 'dark'},
	'Toffee Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/ToffeeM.jpg?4681301725968743650', desc: 'A happy collision of vanilla ganache  and our family recipe of buttercrunch. ', type: 'milk'},
	'Toffee White': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/toffee-white.jpg?v=1614838356', desc: 'A happy collision of vanilla ganache  and our family recipe of buttercrunch. ', type: 'white'},
	'Vanilla Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/vanilla-dark.jpg?v=1614838356', desc: 'Rich white chocolate ganache  infused with pure French vanilla. ', type: 'dark'},
	'Vanilla Milk': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/VanillaM.jpg?4681301725968743650', desc: 'Rich white chocolate ganache  infused with pure French vanilla. ', type: 'milk'},
	'Vanilla White': {img: '//cdn.shopify.com/s/files/1/1342/4693/files/VanillaW.jpg?4681301725968743650', desc: 'Rich white chocolate ganache  infused with pure French vanilla. ', type: 'white'},
//    'Vanilla Mint Dark': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/unknown-dark-2.jpg?v=1614838356', desc: 'White chocolate truffle with Mauritius vanilla and peppermint, sprinkled with crushed candy cane.', type: 'dark'},
//	'Vanilla Mint Milk': {img: 'https://cdn.shopify.com/s/files/1/1342/4693/files/unknown-dark-2.jpg?v=1614838356', desc: 'White chocolate truffle with Mauritius vanilla and peppermint, sprinkled with crushed candy cane.', type: 'milk'},
    };

  	///! Do not edit below this line !///
  	/*********************************************************************************/
  	/*********************************************************************************/
  	/*********************************************************************************/
  	/*********************************************************************************/
  	/*********************************************************************************/
    
  	function set_count_feedback() { 
      	if ( jQuery("#product-select-option-0").length == 0 ) { return; }
      	
      	var other = jQuery("#ts_customizable_picker .selections").find('[data-type="other"]');  		
	  	other.each(function(inx, el) { 
	  		jQuery(el).remove();
	  	});


	  	var boxsize = jQuery("#product-select-option-0").val();
	  	var boxlimits = tsboxes[boxsize]; 
	  	if(boxlimits.other == 0 && boxlimits.milk == boxsize && boxlimits.dark == boxsize && boxlimits.white == boxsize) { 
	  		jQuery(".limited_box").hide();
	  	}
	  	else { 
	  		jQuery(".limited_box").show();
	  	}
	  	jQuery("#ts_customizable_picker .milk_total").html(boxlimits.milk);
	  	jQuery("#ts_customizable_picker .dark_total").html(boxlimits.dark);
	  	jQuery("#ts_customizable_picker .white_total").html(boxlimits.white);
			jQuery("#ts_customizable_picker .non_truffle_count").html(boxlimits.other);
	  	jQuery("#ts_customizable_picker .total").html(boxsize);
	  	jQuery("#ts_customizable_picker .num_selected").html(boxlimits.other); 
	  	for(i=0;i<boxlimits.other;i++) { 
	  		 jQuery("#ts_customizable_picker .selections").append(jQuery('<a class="dummy" data-choice="Other" data-type="other"></a>')); 
	  	}
  	}
    function set_list_selections() { 
		jQuery("#ts_customizable_contents .ts_customizable_contents_template .configure_link").show();
		jQuery("#ts_customizable_selection_list").html('');
		jQuery("#ts_customizable_inputs_dropzone").html('');
		var output = {};
		jQuery("#ts_customizable_picker .main .selections a").each(function(inx) { 
			output[jQuery(this).attr("data-choice")]=0;
		});
		jQuery("#ts_customizable_picker .main .selections a").each(function(inx) { 
			output[jQuery(this).attr("data-choice")]++; 
		}); 
		jQuery.each(output, function(key, value) { 
			var list_item = '<li>'+key+ ' X'+value+'</li>';
			var custominput = '<input type="hidden" name="properties[_custombox]['+key+']" value="'+value+'">';
			var custominputDisplay = '<input type="hidden" name="properties['+key+']" value="'+value+'">';
			jQuery("#ts_customizable_selection_list").append(list_item);
			jQuery("#ts_customizable_inputs_dropzone").append(custominput);
			jQuery("#ts_customizable_inputs_dropzone").append(custominputDisplay);
		});
		jQuery("#ts_customizable_picker").hide();
		jQuery("html").css("overflow", "auto");

		jQuery("#ts_customizable_contents .ts_customizable_contents_template .configure_link").show();
    }  	
    function check_if_type_valid(type) { 
    	var boxsize = jQuery("#product-select-option-0").val();
	 	var boxlimits = tsboxes[boxsize]; 
		var selected_type_count = jQuery("#ts_customizable_picker .main .selections").find('[data-type="'+type+'"]');  		
		if( selected_type_count.length < boxlimits[type] ) { return true; }
		return false; 
    }
  	function update_counts() { 
  		var boxsize = jQuery("#product-select-option-0").val();
  		var boxlimits = tsboxes[boxsize]; 
		var milk = jQuery("#ts_customizable_picker .main .selections").find('[data-type="milk"]');  		
		var dark = jQuery("#ts_customizable_picker .main .selections").find('[data-type="dark"]');  		
		var white = jQuery("#ts_customizable_picker .main .selections").find('[data-type="white"]');  		
  		jQuery("#ts_customizable_picker .milk_selected").html(milk.length);
  		jQuery("#ts_customizable_picker .dark_selected").html(dark.length);
  		jQuery("#ts_customizable_picker .white_selected").html(white.length);
  		jQuery("#ts_customizable_picker .num_selected").html(jQuery("#ts_customizable_picker .main .selections a").length);
  		if(jQuery("#ts_customizable_picker .main .selections a.library-item").length > 12) { 
  			jQuery("#ts_customizable_picker .selections_wrap").addClass("compact"); 
  		}
  		else if(jQuery("#ts_customizable_picker .main .selections a.library-item").length > 24) {
  			jQuery("#ts_customizable_picker .selections_wrap").addClass("supercompact"); 
  		} else {                                                                  
  			jQuery("#ts_customizable_picker .selections_wrap").removeClass("compact"); 
  		}
  		if(jQuery("#ts_customizable_picker .main .selections a").length == jQuery("#product-select-option-0").val()) { 
  			jQuery("#ts_customizable_picker .selections_wrap .confirm_selection").show();
  		} else { 
  			jQuery("#ts_customizable_picker .selections_wrap .confirm_selection").hide();
  		}
  	}

  	function set_item_count(identifier) { 
  		var check = jQuery('#ts_customizable_picker .main .selections a[data-choice="'+identifier+'"]'); 
  		jQuery('#ts_customizable_picker .selections').find(".quantity").html("X"+(check.length));		
  		jQuery('#ts_customizable_picker .selections .mobile').find(".quantity").html("X"+(check.length));		
  	}
  	function check_quantity() { 
  		if(jQuery("#ts_customizable_picker .main .selections a").length == jQuery("#product-select-option-0").val()) { 
  			return true; 
  		}
  		return false; 
  	}
  	function remove_from_selection(el) { 
  		var identifier = jQuery(el).attr("data-choice"); 
  		var check = jQuery('#ts_customizable_picker .main .selections a.dummy[data-choice="'+identifier+'"]'); 
  		var checkMobile = jQuery('#ts_customizable_picker  .selections a.dummy[data-choice="'+identifier+'"]'); 
  		
        if(check.length) { 
  			jQuery(check[0]).remove();
            jQuery(checkMobile[0]).remove(); 
  			set_item_count(identifier); 
  		}
  		else { 
          jQuery('#ts_customizable_picker  .selections a[data-choice="'+identifier+'"]').remove(); 
          
        }
  		update_counts();
  	}
  	function add_selection(identifier) { 
  		var check = jQuery('#ts_customizable_picker .main .selections a[data-choice="'+identifier+'"]'); 
  		if(check.length > 0) { 
  			var dummy = jQuery('<a class="dummy" data-choice="'+identifier+'" data-type="'+check.data("type")+'"></a>'); 
  			jQuery("#ts_customizable_picker .selections").append(dummy); 
  			check.find(".quantity").html("X"+(check.length+1));	
            jQuery('#ts_customizable_picker .selections a[data-choice="'+identifier+'"]').find(".quantity").html("X"+(check.length+1));	
  		}
  		else {      
  			var clone = jQuery('#ts_customizable_picker .choices a[data-choice="'+identifier+'"]').clone(); ; 
  			jQuery(clone).on("click", function(ev) { 
  				ev.preventDefault;
  				ev.stopPropagation(); 
  				remove_from_selection( jQuery(this) );    	
  			});    
  			jQuery("#ts_customizable_picker .selections").prepend(clone); 
  		}
  		update_counts();
  	}
  
 

  	/*Setup Picker*/
  	jQuery.each( tschoices, function( key, value ) {
  		var libimg = jQuery('<a class="library-item" data-type="'+value.type+'" data-choice="'+key+'"></a>');
  		libimg.append('<div style="background-image:url('+value.img+')"><!--<img src="'+value.img+'" alt="'+key+'" />--></div>');
  		libimg.append('<span class="title">'+key+'</span>');
  		libimg.append('<span class="quantity"></span>');
  		libimg.append('<span class="desc"><strong>'+key+':</strong> '+value.desc+'</span>');
  		jQuery("#ts_customizable_picker .choices").append(libimg); 
  	});
  	set_count_feedback();

  	jQuery("#ts_customizable_picker .selections_wrap .confirm_selection").hide();

  	var urlParams;
  

  
  	(window.onpopstate = function () {
  		var match,
        	pl     = /\+/g,  // Regex for replacing addition symbol with a space
        	search = /([^&=]+)=?([^&]*)/g,
        	decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        	query  = window.location.search.substring(1);
        	urlParams = {};
        	while (match = search.exec(query))
        		urlParams[decode(match[1])] = decode(match[2]);
        })();
  
  
  
  
  
    jQuery('.ts_customizable_contents_template input[value="'+urlParams.contents+'"]').prop("checked", true); 


    delete urlParams['contents']; 
    delete urlParams['variant']; 


    jQuery.each( urlParams, function( key, value ) {  
      if (jQuery.isNumeric(value) && parseInt(value) < 100) {
      var list_item = '<li>'+key+ ' X'+value+'</li>';
      var custominput = '<input type="hidden" name="properties[_custombox]['+key+']" value="'+value+'">';
      var custominputDisplay = '<input type="hidden" name="properties['+key+']" value="'+value+'">';
      jQuery("#ts_customizable_selection_list").append(list_item);
      jQuery("#ts_customizable_inputs_dropzone").append(custominput);
      jQuery("#ts_customizable_inputs_dropzone").append(custominputDisplay);

      for(i=0;i<value;i++) { add_selection(key); }
      jQuery("#ts_customizable_contents .ts_customizable_contents_template .configure_link").show();
      }
    }); 



    /*Events*/
    jQuery('html').on("click", function() { 
      set_list_selections();
    });
    jQuery("#ts_customizable_picker .selections_wrap, #ts_customizable_picker .choices_wrap").on("click", function(ev) { 
      ev.preventDefault;
      ev.stopPropagation(); 	
    });
    jQuery("#ts_customizable_contents .ts_customizable_contents_template .configure_link").on("click", function(ev) { 
      jQuery('.ts_customizable_contents_template input[value="custom"]').trigger("change");
      ev.preventDefault;
      ev.stopPropagation(); 	
    });
    jQuery("#ts_customizable_picker .selections_wrap .confirm_selection").on("click", function(ev) { 
      ev.preventDefault;
      ev.stopPropagation(); 	
      if( jQuery("#product-select-option-0").val() == jQuery("#ts_customizable_picker .main .selections a").length ) { 
        set_list_selections();
      }
      else { 
        var left = jQuery("#product-select-option-0").val() - jQuery("#ts_customizable_picker .main .selections a").length;
        var msg = tsmessages["boxnotfull"].replace("[qty_left]", left);
        alert(msg);
      }
    });  
    jQuery(".library-item").on("click", function(ev) { 
      ev.preventDefault;
      ev.stopPropagation(); 
      var boxsize = jQuery("#product-select-option-0").val();
      if(jQuery("#ts_customizable_picker .main .selections a").length >= boxsize) { 
        return; 
      }
      if( !check_if_type_valid( jQuery(this).data("type") ) ) { 
        return;
      }
      add_selection( jQuery(this).attr("data-choice") );
    }); 
    jQuery("#add").on("click", function(ev) { 
      if(jQuery(".ts_customizable_contents_template input:checked").val() == "custom") { 
        if(!check_quantity()) { 
          var left = jQuery("#product-select-option-0").val() - jQuery("#ts_customizable_picker .selections a").length;
          if(left > 0) { 
            var msg = tsmessages.boxnotfull.replace("[qty_left]", left);
          }
          else if(left < 0) { 
            var msg = tsmessages.boxtoofull.replace("[qty_over]", -left);
          }       
          alert(msg);              
          ev.preventDefault;
          ev.stopPropagation(); 
          return false; 
        }
      }
    });
    jQuery("#ts_customizable_picker .selections_wrap #clear_selections").on("click", function() { 
      var conf = confirm(tsmessages['confirmclearselections']); 
      if(conf) { 
        jQuery("#ts_customizable_selection_list").html('');
        jQuery("#ts_customizable_inputs_dropzone").html('');
        jQuery("#ts_customizable_picker .selections").html('');
        set_count_feedback();
      }
    });
    jQuery("#product-select-option-0").on("change", function() { 
      set_count_feedback();
      update_counts();
    });
    jQuery(".ts_customizable_contents_template input").on("change", function() { 
      if(jQuery(this).val()=="custom") { 
        jQuery("#ts_customizable_picker .total").html(jQuery("#product-select-option-0").val());
        jQuery("#ts_customizable_picker").fadeIn();
        jQuery("html").css("overflow", "hidden");
      } 
      else { 
        jQuery("#ts_customizable_selection_list").html('');
        jQuery("#ts_customizable_inputs_dropzone").html('');
        jQuery("#ts_customizable_contents .ts_customizable_contents_template .configure_link").hide();
        jQuery("#ts_customizable_picker").hide();
        jQuery("html").css("overflow", "auto");

      }
    }); 
});